import React, { useState } from 'react';
import { SearchBox, AutoComplete } from 'tea-component';
import classnames from 'classnames';
import { getTextWithHighlight } from '../../utils';
import { IKeywordsSelector } from '../../interfaces';
import { useIntl } from 'umi';
import './index.scss';

const KeywordsSelector: React.FC<IKeywordsSelector> = (props) => {
  const { entityType, onChange, similarGames } = props;
  const { formatMessage } = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [keywords, setKeywords] = useState<any[]>([]);

  const handleOpenChange = (flag: boolean) => {
    setIsOpen(flag);
  };

  const handleKeywordChange = async (keyword: string) => {
    const targetKeyword = keyword.replace(/^\s*/g, '');
    if (!targetKeyword) {
      setKeyword('');
      setKeywords([]);
      setIsOpen(false);
      if (onChange instanceof Function) {
        onChange('');
      }
      return;
    }

    if (!entityType) return;

    // const reg = new RegExp(targetKeyword, 'ig');
    setKeyword(targetKeyword);
    const filterList = similarGames.filter((item) => item?.entityName?.toLocaleLowerCase()?.includes(keyword?.toLocaleLowerCase()));

    // const filterList = similarGames.filter((item) => reg.test(item.entityName));
    const newKeywords = filterList.map((item) => ({
      value: item.id,
      text: getTextWithHighlight(item.entityName, targetKeyword),
    }));
    setKeywords(newKeywords);
  };

  const handleKeywordSelect = (value?: string) => {
    const _value = value || '';
    const game = similarGames.find((item) => item.id === value);
    if (game) {
      setKeyword(game?.entityName);
    }
    setIsOpen(false);
    if (onChange instanceof Function) {
      onChange(_value);
    }
  };

  const handleKeywordSelectClick = (value?: string) => {
    const game = similarGames.find((item) => item.id === value);
    if (game) {
      setKeyword(game?.entityName);
      setIsOpen(false);
      if (onChange instanceof Function) {
        onChange(game?.entityName);
      }
    }
  };

  return (
    <div className="dbi-benchmark-keyword-selector">
      <AutoComplete
        open={!!keyword && isOpen}
        placementOffset={0}
        overlayClassName={classnames('dbi-benchmark-keyword-selector-overlay', {
          empty: !keywords?.length,
        })}
        options={keywords}
        onOpenChange={handleOpenChange}
        onChange={handleKeywordSelectClick}
      >
        {(ref) => (
          <SearchBox
            ref={ref}
            placeholder={formatMessage({id: 'dbi_search_any_game'})}
            value={keyword}
            onSearch={handleKeywordSelect}
            onChange={handleKeywordChange}
          />
        )}
      </AutoComplete>
    </div>
  );
};

export default KeywordsSelector;
